import * as React from 'react'
import { LinkToRedirect } from '..'
import { CompareCredit } from '../../../types/compare-credit'
import { CardArt } from '../card-art'
import Link from 'next/link'

import { supify } from '../../utils'
import { clickRatesAndFees } from '../../clients/segment'
import { ApplyNowIcon } from '../link-to-redirect/ApplyNowIcon'

export function RecapTableCell(props: {
  card: CompareCredit.FormattedCard
  categoryId: string
  externalId: string
  orderId: string
  productHighlight: string
  ribbonText?: string
  ribbonColor?: string
}) {
  const {
    card,
    externalId,
    orderId,
    productHighlight,
    ribbonColor,
    ribbonText,
  } = props
  return (
    <tr
      className={`${
        ribbonColor === 'tetriary'
          ? 'border-tetriary border-2'
          : 'border border-slate-300'
      }`}
    >
      <td>
        {ribbonText ? (
          <div
            className={`inline-block / -ml-4 mb-2 -mt-8 / pl-4 pr-8 / font-bold ${
              ribbonColor === 'tetriary' ? 'c-ribbon-bg-rt text-primary' : null
            }
        ${
          ribbonColor === 'blue'
            ? 'c-ribbon-bg-rt c-ribbon-bg-rt--primary-bright text-white'
            : null
        }
        ${
          ribbonColor === 'none'
            ? 'w-full mb-2 text-primary-bright text-fs13 leading-4 font-bold'
            : null
        }`}
          >
            {ribbonText}
          </div>
        ) : null}

        <div className="c-card-art / mb-1 sm:mb-1.5 lg:mb-2">
          <LinkToRedirect
            externalId={externalId}
            linkParams={card.applyNowLinkParameters}
            orderId={orderId}
            query={undefined}
            slug={card.slug}
          >
            <div className="relative flex rounded-sm overflow-hidden / w-16 xxs:w-20 md:w-24 / shadow-lg / fs_card-tile_card-art">
              <span className="c-card-art__content / absolute / flex flex-wrap content-center items-center justify-center / z-10 left-0 / w-full h-full / leading-4 text-center text-white text-xs font-bold">
                <span className="w-4 h-4 mb-0.5 / hidden xxs:block">
                  <ApplyNowIcon
                    className="inline-block"
                    width={16}
                    height={16}
                    aria-hidden={true}
                  />
                </span>
                <span className="w-full font-semibold">Apply Now</span>
              </span>

              <CardArt
                cardArt={card.cardArt}
                imgClasses="relative / z-0 / w-full h-full object-cover top-0"
                customCodeSnippets={card.customCodeSnippets}
                issuer={card.issuer.slug.current}
                name={card.name}
                orderId={orderId}
                slug={card.slug}
                type={card._type}
                categoryId="80"
                externalId="80"
                _rev={null}
              />
            </div>
          </LinkToRedirect>
        </div>
        <p>
          <LinkToRedirect
            externalId={externalId}
            linkParams={card.applyNowLinkParameters}
            orderId={orderId}
            query={undefined}
            slug={card.slug}
          >
            <div
              className="inline-block / w-full / text-primary-mid leading-snug font-bold text-sm / hover:text-primary-bright cursor-pointer / transition-all"
              dangerouslySetInnerHTML={{
                __html: supify(card.name),
              }}
            />
          </LinkToRedirect>
        </p>
      </td>
      <td>
        <b>{productHighlight}</b>
      </td>
      <td>{card.bonusSignUp}</td>
      <td>{card.rewardsRate}</td>
      <td>
        <LinkToRedirect
          externalId={externalId}
          linkParams={card.applyNowLinkParameters}
          orderId={orderId}
          query={undefined}
          slug={card.slug}
        >
          <div className="inline-block / w-full / px-2 py-2 / text-sm text-white font-bold text-center / bg-green-cta rounded-sm / hover:bg-green-cta-light">
            Apply Now
            <span className="w-4 h-4 / ml-2 / hidden">
              <ApplyNowIcon width={16} height={16} className="lazyload" />
            </span>
          </div>
        </LinkToRedirect>
        {card._type === 'card' &&
          card.ratesAndFees &&
          card.ratesAndFees !== 'N/A' && (
            <p className="pt-1 text-primary-bright-dark text-xs w-full text-center hover:text-primary-bright">
              <Link
                href={card.ratesAndFees}
                onClick={() => {
                  clickRatesAndFees({
                    applyNowLink: card.applyNowLink,
                    component: 'Recap Sell Tips Summary',
                    name: card.name,
                    url: window.location.href,
                  })
                }}
                rel="noopener noreferrer"
                target="_blank"
              >
                Rates &amp; Fees
              </Link>
            </p>
          )}
      </td>
      <style jsx>{`
        th,
        td {
          padding: 1rem;
          vertical-align: top;
          border-collapse: collapse;
        }
        td:last-child {
          vertical-align: middle;
        }
        td {
          border-right: 1px solid #e5e5e5;
        }
      `}</style>
    </tr>
  )
}
